// Utility to build a combined key for identifying a surface or module using the type and key
export const buildCombinedKey = (type: string, key: string): string => {
	return `${type},${key}`;
};
